interface IAlternativeSeparator {
  sector?: boolean;
}

export const AlternativeSeparator = ({ sector = false }: IAlternativeSeparator) =>
  sector ? (
    <>
      <div className="border border-l-[0.5px] border-solid border-[#f1f1f8]" />
    </>
  ) : (
    <hr className="-mx-12 my-8 h-px border-none bg-[#f1f1f8] outline-none" />
  );

AlternativeSeparator.displayName = 'Separator';
